import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { RouterService } from '../../../core/services/router.service';

@Component({
  selector:        'app-navbar',
  imports: [
    NgClass
  ],
  templateUrl:     './navbar.component.html',
  styleUrl:        './navbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavbarComponent {

  public routerService = inject(RouterService);

  @Input()
  backURL: string;

  @Input()
  skipMobileView = false;

  @Output()
  navClick = new EventEmitter();

  clickNav() {
    this.navClick.emit()
    if(this.backURL){
      this.routerService.navigate(this.backURL)
    }
  }
}
